module.exports = __webpack_public_path__ + "static/img/澄悅.9a46b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/澄悅.png?20181011
// module id = l+O4
// module chunks = 1